import React, { createContext, useState, useContext, useEffect } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem('seedoza_cart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  useEffect(() => {
    localStorage.setItem('seedoza_cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = (item) => {
    setCart(prevCart => {
      const existingItem = prevCart.find(
        i => i.product_id === item.product_id && i.variant_size === item.variant_size
      );
      
      if (existingItem) {
        return prevCart.map(i =>
          i.product_id === item.product_id && i.variant_size === item.variant_size
            ? { ...i, quantity: i.quantity + item.quantity }
            : i
        );
      }
      
      return [...prevCart, item];
    });
  };

  const removeFromCart = (product_id, variant_size) => {
    setCart(prevCart => 
      prevCart.filter(item => 
        !(item.product_id === product_id && item.variant_size === variant_size)
      )
    );
  };

  const updateQuantity = (product_id, variant_size, quantity) => {
    if (quantity <= 0) {
      removeFromCart(product_id, variant_size);
      return;
    }
    
    setCart(prevCart =>
      prevCart.map(item =>
        item.product_id === product_id && item.variant_size === variant_size
          ? { ...item, quantity }
          : item
      )
    );
  };

  const clearCart = () => {
    setCart([]);
  };

  const getCartTotal = () => {
    return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
  };

  const getCartCount = () => {
    return cart.reduce((count, item) => count + item.quantity, 0);
  };

  return (
    <CartContext.Provider value={{
      cart,
      addToCart,
      removeFromCart,
      updateQuantity,
      clearCart,
      getCartTotal,
      getCartCount
    }}>
      {children}
    </CartContext.Provider>
  );
};
